import React, { ReactElement, RefObject } from 'react';
import { Collapse, Tooltip } from '@mui/material';
import { ArrowLeftCircleIcon } from '@heroicons/react/24/solid';
import { ParentSidebarNavItem, SidebarHeader } from '../../../types';

interface SidebarCollapsibleHeaderProps {
  isCollapsed: boolean;
  isCollapsing: boolean;
  isClickingArrow: boolean;
  hasAdminAccess: boolean;
  arrowRef: RefObject<SVGSVGElement>;
  navItems: Array<ParentSidebarNavItem>;
  startCollapse: () => void;
  startExpand: () => void;
}

const SidebarCollapsibleHeader = ({
  isCollapsed,
  isCollapsing,
  isClickingArrow,
  hasAdminAccess,
  arrowRef,
  navItems,
  startCollapse,
  startExpand,
}: SidebarCollapsibleHeaderProps): ReactElement => {
  return (
    <div
      className={`h-6 flex justify-between items-center ${!hasAdminAccess ? 'mb-4' : 'my-4'}`}
    >
      {!isCollapsed && (
        <Collapse in={!isCollapsing} orientation="horizontal">
          <div className="text-slate-400 text-xs font-medium uppercase tracking-widest whitespace-nowrap">
            {navItems.length === 0 ? '' : SidebarHeader.MY_ACCOUNT}
          </div>
        </Collapse>
      )}
      {!hasAdminAccess && (
        <Tooltip
          title={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
          placement="right"
          classes={{
            tooltip: 'text-white bg-gray-900 opacity-80 rounded-md shadow-xl',
          }}
        >
          <ArrowLeftCircleIcon
            id="sidebar-collapse-icon"
            ref={arrowRef}
            className={`w-7 h-7 -ml-1 rounded-full ${isClickingArrow
              ? 'text-blue-500 bg-white border-3 border-solid border-slate-800'
              : 'text-slate-400 hover:text-white'
              } cursor-pointer fixed transform ${isCollapsing ? 'rotate-180 translate-x-2.5' : 'translate-x-52'
              } ease-in-out duration-300`}
            onClick={isCollapsed ? startExpand : startCollapse}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default SidebarCollapsibleHeader;
